<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [  
            {
              key: '1',
              title: '考官申报管理'
            }, 
            {
              key: '2',
              title: '考官人员管理'
            },
            {
              key: '3',
              title: '监督申报管理'
            },
            {
              key: '4',
              title: '监督人员管理'
            },
            {
              key: '5',
              title: '导师申报管理'
            },
            {
              key: '6',
              title: '导师人员管理'
            },
            {
              key: '7',
              title: '培训师申报管理'
            },
            {
              key: '8',
              title: '培训师人员管理'
            },
            {
              key: '9',
              title: '等级批量查询'
            }
          ],
          active: () => {
            switch (this.$route.path) { 
              case '/qcxj/KaoguanList':
                return '1'
              case '/qcxj/KaoguanMemberList':
                return '2'
              case '/qcxj/JianduList':
                return '3'
              case '/qcxj/JianduMemberList':
                return '4'
              case '/qcxj/DaoshiList':
                return '5'
              case '/qcxj/DaoshiMemberList':
                return '6'
              case '/qcxj/PeixunshiList':
                return '7'
              case '/qcxj/PeixunshiMemberList':
                return '8'
              case '/qcxj/KaoguanjianduGrade':
                return '9'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) { 
              case '1':
                this.$router.push('/qcxj/KaoguanList')
                break 
              case '2':
                this.$router.push('/qcxj/KaoguanMemberList')
                break
              case '3':
                this.$router.push('/qcxj/JianduList')
                break
              case '4':
                this.$router.push('/qcxj/JianduMemberList')
                break
              case '5':
                this.$router.push('/qcxj/DaoshiList')
                break
              case '6':
                this.$router.push('/qcxj/DaoshiMemberList')
                break
              case '7':
                this.$router.push('/qcxj/PeixunshiList')
                break
              case '8':
                this.$router.push('/qcxj/PeixunshiMemberList')
                break
              case '9':
                this.$router.push('/qcxj/KaoguanjianduGrade')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
